@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_969_658_038)
internal val Res.drawable.nether_quartz_ore: DrawableResource by lazy {
      DrawableResource("drawable:nether_quartz_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_quartz_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_990_261_176)
internal val Res.drawable.nether_sprouts: DrawableResource by lazy {
      DrawableResource("drawable:nether_sprouts", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_sprouts.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_528_062_159)
internal val Res.drawable.nether_star: DrawableResource by lazy {
      DrawableResource("drawable:nether_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_star.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_425_401_362)
internal val Res.drawable.nether_wart: DrawableResource by lazy {
      DrawableResource("drawable:nether_wart", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_wart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-278_440_796)
internal val Res.drawable.nether_wart_block: DrawableResource by lazy {
      DrawableResource("drawable:nether_wart_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_wart_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_465_558_675)
internal val Res.drawable.netherite_axe: DrawableResource by lazy {
      DrawableResource("drawable:netherite_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-759_749_119)
internal val Res.drawable.netherite_block: DrawableResource by lazy {
      DrawableResource("drawable:netherite_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_017_898_748)
internal val Res.drawable.netherite_boots: DrawableResource by lazy {
      DrawableResource("drawable:netherite_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_601_704_619)
internal val Res.drawable.netherite_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:netherite_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(787_033_370)
internal val Res.drawable.netherite_helmet: DrawableResource by lazy {
      DrawableResource("drawable:netherite_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-240_733_562)
internal val Res.drawable.netherite_hoe: DrawableResource by lazy {
      DrawableResource("drawable:netherite_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_362_447_867)
internal val Res.drawable.netherite_ingot: DrawableResource by lazy {
      DrawableResource("drawable:netherite_ingot", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_ingot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-70_506_096)
internal val Res.drawable.netherite_leggings: DrawableResource by lazy {
      DrawableResource("drawable:netherite_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_896_713_610)
internal val Res.drawable.netherite_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:netherite_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(895_277_349)
internal val Res.drawable.netherite_scrap: DrawableResource by lazy {
      DrawableResource("drawable:netherite_scrap", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_scrap.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-514_951_388)
internal val Res.drawable.netherite_shovel: DrawableResource by lazy {
      DrawableResource("drawable:netherite_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_140_567_276)
internal val Res.drawable.netherite_sword: DrawableResource by lazy {
      DrawableResource("drawable:netherite_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherite_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_810_859_682)
internal val Res.drawable.netherrack: DrawableResource by lazy {
      DrawableResource("drawable:netherrack", setOf(
        ResourceItem(setOf(), "${MD}drawable/netherrack.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_245_806_140)
internal val Res.drawable.note_block: DrawableResource by lazy {
      DrawableResource("drawable:note_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/note_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_847_730_707)
internal val Res.drawable.oak_boat: DrawableResource by lazy {
      DrawableResource("drawable:oak_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_043_385_476)
internal val Res.drawable.oak_button: DrawableResource by lazy {
      DrawableResource("drawable:oak_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_885_180_227)
internal val Res.drawable.oak_door: DrawableResource by lazy {
      DrawableResource("drawable:oak_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-792_163_586)
internal val Res.drawable.oak_fence: DrawableResource by lazy {
      DrawableResource("drawable:oak_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-147_350_031)
internal val Res.drawable.oak_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:oak_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(385_540_379)
internal val Res.drawable.oak_leaves: DrawableResource by lazy {
      DrawableResource("drawable:oak_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_111_740_758)
internal val Res.drawable.oak_log: DrawableResource by lazy {
      DrawableResource("drawable:oak_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_647_489_992)
internal val Res.drawable.oak_planks: DrawableResource by lazy {
      DrawableResource("drawable:oak_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_973_022_307)
internal val Res.drawable.oak_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:oak_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_682_612_970)
internal val Res.drawable.oak_sapling: DrawableResource by lazy {
      DrawableResource("drawable:oak_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(226_021_154)
internal val Res.drawable.oak_sign: DrawableResource by lazy {
      DrawableResource("drawable:oak_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(233_670_920)
internal val Res.drawable.oak_slab: DrawableResource by lazy {
      DrawableResource("drawable:oak_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(383_619_623)
internal val Res.drawable.oak_stairs: DrawableResource by lazy {
      DrawableResource("drawable:oak_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-353_431_134)
internal val Res.drawable.oak_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:oak_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-767_960_035)
internal val Res.drawable.oak_wood: DrawableResource by lazy {
      DrawableResource("drawable:oak_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/oak_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(497_874_446)
internal val Res.drawable.observer: DrawableResource by lazy {
      DrawableResource("drawable:observer", setOf(
        ResourceItem(setOf(), "${MD}drawable/observer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_926_390_145)
internal val Res.drawable.obsidian: DrawableResource by lazy {
      DrawableResource("drawable:obsidian", setOf(
        ResourceItem(setOf(), "${MD}drawable/obsidian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-155_244_277)
internal val Res.drawable.ocelot_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:ocelot_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/ocelot_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(397_430_846)
internal val Res.drawable.orange_banner: DrawableResource by lazy {
      DrawableResource("drawable:orange_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_128_055_602)
internal val Res.drawable.orange_bed: DrawableResource by lazy {
      DrawableResource("drawable:orange_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_487_416_915)
internal val Res.drawable.orange_carpet: DrawableResource by lazy {
      DrawableResource("drawable:orange_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-478_238_282)
internal val Res.drawable.orange_concrete: DrawableResource by lazy {
      DrawableResource("drawable:orange_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-185_484_354)
internal val Res.drawable.orange_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:orange_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(264_338_297)
internal val Res.drawable.orange_dye: DrawableResource by lazy {
      DrawableResource("drawable:orange_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_679_010_200)
internal val Res.drawable.orange_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:orange_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-84_095_675)
internal val Res.drawable.orange_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:orange_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(404_861_195)
internal val Res.drawable.orange_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:orange_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(553_626_956)
internal val Res.drawable.orange_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:orange_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_540_836_027)
internal val Res.drawable.orange_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:orange_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-787_125_561)
internal val Res.drawable.orange_tulip: DrawableResource by lazy {
      DrawableResource("drawable:orange_tulip", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_tulip.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-484_603_249)
internal val Res.drawable.orange_wool: DrawableResource by lazy {
      DrawableResource("drawable:orange_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_580_427_534)
internal val Res.drawable.oxeye_daisy: DrawableResource by lazy {
      DrawableResource("drawable:oxeye_daisy", setOf(
        ResourceItem(setOf(), "${MD}drawable/oxeye_daisy.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(503_611_197)
internal val Res.drawable.packed_ice: DrawableResource by lazy {
      DrawableResource("drawable:packed_ice", setOf(
        ResourceItem(setOf(), "${MD}drawable/packed_ice.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(525_064_225)
internal val Res.drawable.painting: DrawableResource by lazy {
      DrawableResource("drawable:painting", setOf(
        ResourceItem(setOf(), "${MD}drawable/painting.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-676_744_639)
internal val Res.drawable.panda_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:panda_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/panda_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-867_548_949)
internal val Res.drawable.paper: DrawableResource by lazy {
      DrawableResource("drawable:paper", setOf(
        ResourceItem(setOf(), "${MD}drawable/paper.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_114_246_385)
internal val Res.drawable.parrot_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:parrot_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/parrot_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_162_425_162)
internal val Res.drawable.peony: DrawableResource by lazy {
      DrawableResource("drawable:peony", setOf(
        ResourceItem(setOf(), "${MD}drawable/peony.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(233_670_920)
internal val Res.drawable.petrified_oak_slab: DrawableResource by lazy {
      DrawableResource("drawable:petrified_oak_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/petrified_oak_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_252_326_559)
internal val Res.drawable.phantom_membrane: DrawableResource by lazy {
      DrawableResource("drawable:phantom_membrane", setOf(
        ResourceItem(setOf(), "${MD}drawable/phantom_membrane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(208_326_099)
internal val Res.drawable.phantom_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:phantom_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/phantom_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_676_926_628)
internal val Res.drawable.pig_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:pig_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/pig_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.piglin_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:piglin_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/piglin_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(670_977_523)
internal val Res.drawable.piglin_brute_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:piglin_brute_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/piglin_brute_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_595_792_526)
internal val Res.drawable.piglin_icon: DrawableResource by lazy {
      DrawableResource("drawable:piglin_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/piglin_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_046_024_267)
internal val Res.drawable.piglin_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:piglin_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/piglin_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(349_171_022)
internal val Res.drawable.pillager_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:pillager_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/pillager_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(294_351_321)
internal val Res.drawable.pink_banner: DrawableResource by lazy {
      DrawableResource("drawable:pink_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_674_279_754)
internal val Res.drawable.pink_bed: DrawableResource by lazy {
      DrawableResource("drawable:pink_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-868_455_413)
internal val Res.drawable.pink_carpet: DrawableResource by lazy {
      DrawableResource("drawable:pink_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_571_842_498)
internal val Res.drawable.pink_concrete: DrawableResource by lazy {
      DrawableResource("drawable:pink_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-775_306_523)
internal val Res.drawable.pink_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:pink_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_812_513_726)
internal val Res.drawable.pink_dye: DrawableResource by lazy {
      DrawableResource("drawable:pink_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_326_553_476)
internal val Res.drawable.pink_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:pink_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_482_616_130)
internal val Res.drawable.pink_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:pink_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_293_767_052)
internal val Res.drawable.pink_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:pink_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_609_682_118)
internal val Res.drawable.pink_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:pink_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_506_103_244)
internal val Res.drawable.pink_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:pink_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_175_299_594)
internal val Res.drawable.pink_tulip: DrawableResource by lazy {
      DrawableResource("drawable:pink_tulip", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_tulip.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_650_330_858)
internal val Res.drawable.pink_wool: DrawableResource by lazy {
      DrawableResource("drawable:pink_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/pink_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-996_060_517)
internal val Res.drawable.piston: DrawableResource by lazy {
      DrawableResource("drawable:piston", setOf(
        ResourceItem(setOf(), "${MD}drawable/piston.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_527_586_742)
internal val Res.drawable.player_head: DrawableResource by lazy {
      DrawableResource("drawable:player_head", setOf(
        ResourceItem(setOf(), "${MD}drawable/player_head.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_748_036_883)
internal val Res.drawable.plus_icon: DrawableResource by lazy {
      DrawableResource("drawable:plus_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_161_973_470)
internal val Res.drawable.podzol: DrawableResource by lazy {
      DrawableResource("drawable:podzol", setOf(
        ResourceItem(setOf(), "${MD}drawable/podzol.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_108_380_221)
internal val Res.drawable.poisonous_potato: DrawableResource by lazy {
      DrawableResource("drawable:poisonous_potato", setOf(
        ResourceItem(setOf(), "${MD}drawable/poisonous_potato.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-946_746_879)
internal val Res.drawable.polar_bear_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:polar_bear_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/polar_bear_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_817_469_008)
internal val Res.drawable.polished_andesite: DrawableResource by lazy {
      DrawableResource("drawable:polished_andesite", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_andesite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(768_861_963)
internal val Res.drawable.polished_andesite_slab: DrawableResource by lazy {
      DrawableResource("drawable:polished_andesite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_andesite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-796_454_798)
internal val Res.drawable.polished_andesite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:polished_andesite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_andesite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-424_193_661)
internal val Res.drawable.polished_basalt: DrawableResource by lazy {
      DrawableResource("drawable:polished_basalt", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_basalt.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-341_891_803)
internal val Res.drawable.polished_blackstone: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_565_349_236)
internal val Res.drawable.polished_blackstone_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(128_982_623)
internal val Res.drawable.polished_blackstone_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-575_817_381)
internal val Res.drawable.polished_blackstone_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-139_822_151)
internal val Res.drawable.polished_blackstone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(140_148_845)
internal val Res.drawable.polished_blackstone_button: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-506_674_001)
internal val Res.drawable.polished_blackstone_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(935_971_180)
internal val Res.drawable.polished_blackstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_140_355_373)
internal val Res.drawable.polished_blackstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_514_581_356)
internal val Res.drawable.polished_blackstone_wall: DrawableResource by lazy {
      DrawableResource("drawable:polished_blackstone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_blackstone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-451_835_219)
internal val Res.drawable.polished_diorite: DrawableResource by lazy {
      DrawableResource("drawable:polished_diorite", setOf(
        ResourceItem(setOf(), "${MD}drawable/polished_diorite.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable6Resources(map: MutableMap<String, DrawableResource>) {
  map.put("nether_quartz_ore", Res.drawable.nether_quartz_ore)
  map.put("nether_sprouts", Res.drawable.nether_sprouts)
  map.put("nether_star", Res.drawable.nether_star)
  map.put("nether_wart", Res.drawable.nether_wart)
  map.put("nether_wart_block", Res.drawable.nether_wart_block)
  map.put("netherite_axe", Res.drawable.netherite_axe)
  map.put("netherite_block", Res.drawable.netherite_block)
  map.put("netherite_boots", Res.drawable.netherite_boots)
  map.put("netherite_chestplate", Res.drawable.netherite_chestplate)
  map.put("netherite_helmet", Res.drawable.netherite_helmet)
  map.put("netherite_hoe", Res.drawable.netherite_hoe)
  map.put("netherite_ingot", Res.drawable.netherite_ingot)
  map.put("netherite_leggings", Res.drawable.netherite_leggings)
  map.put("netherite_pickaxe", Res.drawable.netherite_pickaxe)
  map.put("netherite_scrap", Res.drawable.netherite_scrap)
  map.put("netherite_shovel", Res.drawable.netherite_shovel)
  map.put("netherite_sword", Res.drawable.netherite_sword)
  map.put("netherrack", Res.drawable.netherrack)
  map.put("note_block", Res.drawable.note_block)
  map.put("oak_boat", Res.drawable.oak_boat)
  map.put("oak_button", Res.drawable.oak_button)
  map.put("oak_door", Res.drawable.oak_door)
  map.put("oak_fence", Res.drawable.oak_fence)
  map.put("oak_fence_gate", Res.drawable.oak_fence_gate)
  map.put("oak_leaves", Res.drawable.oak_leaves)
  map.put("oak_log", Res.drawable.oak_log)
  map.put("oak_planks", Res.drawable.oak_planks)
  map.put("oak_pressure_plate", Res.drawable.oak_pressure_plate)
  map.put("oak_sapling", Res.drawable.oak_sapling)
  map.put("oak_sign", Res.drawable.oak_sign)
  map.put("oak_slab", Res.drawable.oak_slab)
  map.put("oak_stairs", Res.drawable.oak_stairs)
  map.put("oak_trapdoor", Res.drawable.oak_trapdoor)
  map.put("oak_wood", Res.drawable.oak_wood)
  map.put("observer", Res.drawable.observer)
  map.put("obsidian", Res.drawable.obsidian)
  map.put("ocelot_spawn_egg", Res.drawable.ocelot_spawn_egg)
  map.put("orange_banner", Res.drawable.orange_banner)
  map.put("orange_bed", Res.drawable.orange_bed)
  map.put("orange_carpet", Res.drawable.orange_carpet)
  map.put("orange_concrete", Res.drawable.orange_concrete)
  map.put("orange_concrete_powder", Res.drawable.orange_concrete_powder)
  map.put("orange_dye", Res.drawable.orange_dye)
  map.put("orange_glazed_terracotta", Res.drawable.orange_glazed_terracotta)
  map.put("orange_shulker_box", Res.drawable.orange_shulker_box)
  map.put("orange_stained_glass", Res.drawable.orange_stained_glass)
  map.put("orange_stained_glass_pane", Res.drawable.orange_stained_glass_pane)
  map.put("orange_terracotta", Res.drawable.orange_terracotta)
  map.put("orange_tulip", Res.drawable.orange_tulip)
  map.put("orange_wool", Res.drawable.orange_wool)
  map.put("oxeye_daisy", Res.drawable.oxeye_daisy)
  map.put("packed_ice", Res.drawable.packed_ice)
  map.put("painting", Res.drawable.painting)
  map.put("panda_spawn_egg", Res.drawable.panda_spawn_egg)
  map.put("paper", Res.drawable.paper)
  map.put("parrot_spawn_egg", Res.drawable.parrot_spawn_egg)
  map.put("peony", Res.drawable.peony)
  map.put("petrified_oak_slab", Res.drawable.petrified_oak_slab)
  map.put("phantom_membrane", Res.drawable.phantom_membrane)
  map.put("phantom_spawn_egg", Res.drawable.phantom_spawn_egg)
  map.put("pig_spawn_egg", Res.drawable.pig_spawn_egg)
  map.put("piglin_banner_pattern", Res.drawable.piglin_banner_pattern)
  map.put("piglin_brute_spawn_egg", Res.drawable.piglin_brute_spawn_egg)
  map.put("piglin_icon", Res.drawable.piglin_icon)
  map.put("piglin_spawn_egg", Res.drawable.piglin_spawn_egg)
  map.put("pillager_spawn_egg", Res.drawable.pillager_spawn_egg)
  map.put("pink_banner", Res.drawable.pink_banner)
  map.put("pink_bed", Res.drawable.pink_bed)
  map.put("pink_carpet", Res.drawable.pink_carpet)
  map.put("pink_concrete", Res.drawable.pink_concrete)
  map.put("pink_concrete_powder", Res.drawable.pink_concrete_powder)
  map.put("pink_dye", Res.drawable.pink_dye)
  map.put("pink_glazed_terracotta", Res.drawable.pink_glazed_terracotta)
  map.put("pink_shulker_box", Res.drawable.pink_shulker_box)
  map.put("pink_stained_glass", Res.drawable.pink_stained_glass)
  map.put("pink_stained_glass_pane", Res.drawable.pink_stained_glass_pane)
  map.put("pink_terracotta", Res.drawable.pink_terracotta)
  map.put("pink_tulip", Res.drawable.pink_tulip)
  map.put("pink_wool", Res.drawable.pink_wool)
  map.put("piston", Res.drawable.piston)
  map.put("player_head", Res.drawable.player_head)
  map.put("plus_icon", Res.drawable.plus_icon)
  map.put("podzol", Res.drawable.podzol)
  map.put("poisonous_potato", Res.drawable.poisonous_potato)
  map.put("polar_bear_spawn_egg", Res.drawable.polar_bear_spawn_egg)
  map.put("polished_andesite", Res.drawable.polished_andesite)
  map.put("polished_andesite_slab", Res.drawable.polished_andesite_slab)
  map.put("polished_andesite_stairs", Res.drawable.polished_andesite_stairs)
  map.put("polished_basalt", Res.drawable.polished_basalt)
  map.put("polished_blackstone", Res.drawable.polished_blackstone)
  map.put("polished_blackstone_brick_slab", Res.drawable.polished_blackstone_brick_slab)
  map.put("polished_blackstone_brick_stairs", Res.drawable.polished_blackstone_brick_stairs)
  map.put("polished_blackstone_brick_wall", Res.drawable.polished_blackstone_brick_wall)
  map.put("polished_blackstone_bricks", Res.drawable.polished_blackstone_bricks)
  map.put("polished_blackstone_button", Res.drawable.polished_blackstone_button)
  map.put("polished_blackstone_pressure_plate", Res.drawable.polished_blackstone_pressure_plate)
  map.put("polished_blackstone_slab", Res.drawable.polished_blackstone_slab)
  map.put("polished_blackstone_stairs", Res.drawable.polished_blackstone_stairs)
  map.put("polished_blackstone_wall", Res.drawable.polished_blackstone_wall)
  map.put("polished_diorite", Res.drawable.polished_diorite)
}
